export default "__VITE_PUBLIC_ASSET__595e92c1__"